<script>
	const _ = require('underscore');
	module.exports = {
		name: 'product-selection-hidden-radio-group',
		props: {
			product: {
				required: true
			},
			onProductClick: {
				type: Function,
				default() {}
			},
			visible: {
				type: Boolean,
				default: false
			}
		},
		components: {
			'input-item-with-label': require('components/input-item-with-label.vue').default
		},
		computed: {
			allSelected() {
				const product = this.product;
				const children = product.children || product.subTypes || [];

				return children.every(c => c.selected);
			},
			anySelected() {
				return this.children.some(c => c.selected);
			},
			groupInfo() {
				let product = this.product;
				return product.info;
			},
			parentItem() {
				let product = this.product;

				return {
					text: product.parentText,
					id: product.parentId,
					selected: this.anySelected,
					disabled: product.disabled,
					icon: product.icon,
					hint: product.hint
				};
			},
			allItem() {
				let product = this.product;

				if (!product.allowAll) {
					return null;
				}

				return {
					text: product.allText,
					id: product.allId,
					selected: this.allSelected
				};
			},
			children() {
				const product = this.product;
				const children = product.children || product.subTypes || [];

				return children.map(c => {
					return _.assign({}, c, {
						selected: this.isChildSelected(c)
					});
				});
			}
		},
		methods: {
			selectAll() {
				this.children.forEach(c => {
					this.onProductClick(c, true);
				});
			},
			deselectAll() {
				this.children.forEach(c => {
					this.onProductClick(c, false);
				});
			},
			parentClick() {
				let product = this.product;
				if (product.selectAll !== false) {
					if (this.anySelected) {
						this.deselectAll();
					} else {
						this.selectAll();
					}
				} else if (this.anySelected) {
					this.deselectAll();
				} else if (this.children.length) {
					this.onChildClick(this.children[0]);
				}
			},
			onChildClick(child) {
				this.deselectAll();
				this.onProductClick(child, true);
			},
			isChildSelected(child) {
				if (this.allSelected) {
					return false;
				}
				return child.selected;
			}
		}
	};
</script>
<style lang="scss">
	.product-selection-hidden-radio-group {
	}
</style>
<template>
	<div class="product-selection-hidden-radio-group">
		<input-item-with-label
			v-if="parentItem.text"
			:item="parentItem"
			:on-item-click="parentClick">
		</input-item-with-label>
		<div
			class="product-container margin-left-medium"
			v-show="visible || anySelected">
			<input-item-with-label
				v-if="allItem"
				class="all-option"
				type="radio"
				:name="product.groupName"
				:item="allItem"
				:on-item-click="selectAll">
			</input-item-with-label>
			<input-item-with-label
				v-for="c in children"
				:key="c.id"
				type="radio"
				:name="product.groupName"
				:item="c"
				:on-item-click="onChildClick">
			</input-item-with-label>
		</div>
	</div>
</template>
